// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__5Kzmt","right":"Footer_right__2lSkj","buttons":"Footer_buttons__1GxNz"};